import React from 'react'
import MCAParameterUpdateModalSF from './MCAParameterUpdateModalSF'

const MCABalanceSheetUI = ({ account, context, bsList, yearList, onRefreshClick,
  mcaParameterUpdateMode, onMcaParameterUpdateClick, onMcaParameterUpdateCancel, selectedParameterName
}) =>
  <div id='mcaBalanceSheet' className='g_m_top_200'>
    <span className='g_large'><b>Balance Sheet</b></span>
    <table className='g_table'>
      <thead className='g_sticky'><tr><td />
        {
          bsList.map((bs, i) =>
            <td key={i} className='g_text_right'>
              <b className='g_no_wrap'>{bs.financialYear}</b>
            </td>
          )
        }
      </tr></thead>
      <tbody>
        <tr><td colSpan='8'><b>Equity & Liabilities</b></td></tr>
        <RowUI bsList={bsList} name='equityShareCapital' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='otherEquity' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='reserveSurplus' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='others' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalEquity' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='securedLongTermBorrowings' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='unsecuredLongTermBorrowings' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='longTermProvisions' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='deferredTaxLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='otherNonCurrentLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalNonCurrentLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='securedShortTermBorrowings' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='tradePayables' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='shortTermProvisions' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='currentDeferredTaxLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='otherCurrentLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalCurrentLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalEquityAndLiabilities' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <tr><td colSpan='8'><b className='g_m_top_200'>Assets</b></td></tr>
        <RowUI bsList={bsList} name='tangibleAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='otherTangibleAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='intangibleAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='capitalWorkInProgress' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='intangibleAssetsUnderDevelopment' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='netFixedAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='nonCurrentInvestments' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='longTermLoansAndAdvances' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='deferredTaxAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='otherNonCurrentAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalNonCurrentAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='currentInvestments' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='inventories' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='shortTermLoansAndAdvances' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='tradeReceivables' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='cashAndBankBalances' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} name='otherCurrentAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalCurrentAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI bsList={bsList} total={true} name='totalAssets' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
      </tbody>
    </table>

    <MCAParameterUpdateModalSF
      account={account} context={context}
      updateMode={mcaParameterUpdateMode}
      onCancelClick={onMcaParameterUpdateCancel}
      onRefreshClick={onRefreshClick}
      reportType='balance_sheet'
      selectedParameterName={selectedParameterName}
      yearList={yearList}
    />

  </div>
{/*
  currentTaxAssetsNet;
  financialInstruments;
  nonFinancialInvestments;
  otherFinancialAssets;
  otherNonFinancialAssets;
  totalFinancialAssets;
  totalNonFinancialAssets;
*/}

const RowUI = ({ bsList, total, name, onMcaParameterUpdateClick }) =>
  <tr className={total && 'g_table_total'}>
    <td><Desc name={name} /></td>
    {
      bsList.map((bs, i) =>
        <td key={i} className='g_text_right g_m_left_100'>
          {bs[name]}
        </td>
      )
    }
    <td>
      <span className='icon icon-pencil' onClick={onMcaParameterUpdateClick} data-name={name} />
    </td>
  </tr>

const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'equityShareCapital':
          return 'Equity Share Capital'
        case 'otherEquity':
          return 'Other Equity'
        case 'reserveSurplus':
          return 'Reserve & Surplus'
        case 'others':
          return 'Others'
        case 'totalEquity':
          return 'Total Equity'
        case 'securedLongTermBorrowings':
          return 'Secured Long-term Borrowings'
        case 'unsecuredLongTermBorrowings':
          return 'Unsecured Long-term Borrowings'
        case 'longTermProvisions':
          return 'Long Term Provisions'
        case 'deferredTaxLiabilities':
          return 'Deferred Tax Liabilities'
        case 'otherNonCurrentLiabilities':
          return 'Other Non-Current Liabilities'
        case 'totalNonCurrentLiabilities':
          return 'Total Non-Current Liabilities'
        case 'securedShortTermBorrowings':
          return 'Secured Short-term Borrowings'
        case 'tradePayables':
          return 'Trade Payables'
        case 'shortTermProvisions':
          return 'Short Term Provisions'
        case 'currentDeferredTaxLiabilities':
          return 'Current Deferred Tax Liabilities'
        case 'otherCurrentLiabilities':
          return 'Other Current Liabilities'
        case 'totalCurrentLiabilities':
          return 'Total Current Liabilities'
        case 'totalLiabilities':
          return 'Total Liabilities'
        case 'totalEquityAndLiabilities':
          return 'Total Equity and Liabilities'

        case 'tangibleAssets':
          return 'Tangible Assets'
        case 'otherTangibleAssets':
          return 'Other Tangible Assets'
        case 'intangibleAssets':
          return 'Intangible Assets'
        case 'capitalWorkInProgress':
          return 'Capital Work in Progress'
        case 'intangibleAssetsUnderDevelopment':
          return 'Intangible Assets under Development'
        case 'netFixedAssets':
          return 'Net Fixed Assets'
        case 'nonCurrentInvestments':
          return 'Non-current Investments'
        case 'longTermLoansAndAdvances':
          return 'Long Term Loans & Advances'
        case 'deferredTaxAssets':
          return 'Deferred Tax Assets'
        case 'otherNonCurrentAssets':
          return 'Other Non-Current Assets'
        case 'totalNonCurrentAssets':
          return 'Total Non-current Assets'
        case 'currentInvestments':
          return 'Current Investments'
        case 'inventories':
          return 'Inventories'
        case 'shortTermLoansAndAdvances':
          return 'Short Term Loans & Advances'
        case 'tradeReceivables':
          return 'Trade Receivables'
        case 'cashAndBankBalances':
          return 'Cash and Bank Balances'
        case 'otherCurrentAssets':
          return 'Other Current Assets'
        case 'totalCurrentAssets':
          return 'Total Current Assets'
        case 'totalAssets':
          return 'Total Assets'
        default:
          return name
      }
    })()}
  </span>

export default MCABalanceSheetUI
